






















































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import quotationServices from '@/services/quotation-services';
import commonService from '@/services/common-services';

@Component
export default class ShippingInfo extends Vue {
    @Prop({ required: true })
    private quotation!: any;

    private showPortModal: boolean = false;
    private isSavingPorts: boolean = false;
    private editPortDeparture: string = '';
    private editPortArrival: string = '';
    private portsList: any[] = [];

    // Modal chọn kho TQ & VN
    private showWarehouseCNModal: boolean = false;
    private showWarehouseVNModal: boolean = false;
    private isSavingWarehouse: boolean = false;
    private chinaStoresList: any[] = [];
    private allChinaStoresList: any[] = [];
    private vnStoresList: any[] = [];
    private allVnStoresList: any[] = [];
    private selectedChinaStoreId: number | null = null;
    private selectedChinaStoreName: string = '';
    private selectedVnStoreId: number | null = null;
    private selectedVnStoreName: string = '';

    private async mounted() {
        await Promise.all([
            this.loadChinaStores(),
            this.loadVnStores(),
            this.isPortCondition ? this.loadPorts() : Promise.resolve(),
        ]);
    }

    private get isPortCondition(): boolean {
        const cond = String((this.quotation && this.quotation.declaration_condition) || '').toUpperCase().trim();
        return ['LCL', 'FCL'].includes(cond);
    }

    private get isBeforeWarehouseVN(): boolean {
        if (!this.quotation) return false;
        const status = String(this.quotation.status || '').toLowerCase().trim().replace(/_/g, '-');
        const postArrivalStatuses = [
            'da-nhap-kho-nhan',
            'nhap-kho-vn',
            've-kho-vn',
            'da-xuat-kho',
            'xuat-kho-vn',
            'hoan-thanh',
            'huy',
        ];
        if (postArrivalStatuses.includes(status)) {
            return false;
        }
        const statusDisplay = String(this.quotation.status_display || '').toLowerCase().trim();
        if (
            statusDisplay.includes('nhập kho vn') ||
            statusDisplay.includes('đã nhập kho vn') ||
            statusDisplay.includes('xuất kho') ||
            statusDisplay.includes('hoàn thành') ||
            statusDisplay.includes('đã hủy')
        ) {
            return false;
        }
        return true;
    }

    private get canChangeWarehouseCN(): boolean {
        return this.isBeforeWarehouseVN;
    }

    private get canChangeWarehouseVN(): boolean {
        return this.isBeforeWarehouseVN;
    }

    private get displayWarehouseCN(): string {
        if (!this.quotation) return 'Kho chính ngạch TQ';

        const storeId = this.quotation.legacy_china_store_id;
        const whCn = String(this.quotation.warehouse_cn || '').trim();
        const isNumeric = /^\d+$/.test(whCn);

        // 1. Tìm theo legacy_china_store_id hoặc ID số trong danh sách kho
        const targetId = storeId || (isNumeric ? parseInt(whCn, 10) : null);
        if (targetId && this.allChinaStoresList && this.allChinaStoresList.length > 0) {
            const found = this.allChinaStoresList.find((s: any) => String(s.ID) === String(targetId));
            if (found && found.Name) {
                return found.Name;
            }
        }

        // 2. Nếu warehouse_cn là tên hợp lệ (không phải số ID)
        if (whCn && !isNumeric) {
            return whCn;
        }

        // 3. Fallback
        if (targetId) {
            return `Kho #${targetId}`;
        }
        return 'Kho chính ngạch TQ';
    }

    private get displayWarehouseVN(): string {
        if (!this.quotation) return this.defaultWarehouseVn;

        const storeId = this.quotation.legacy_receive_place_id;
        const whVn = String(this.quotation.warehouse_vn || '').trim();
        const isNumeric = /^\d+$/.test(whVn);

        const targetId = storeId || (isNumeric ? parseInt(whVn, 10) : null);
        if (targetId && this.allVnStoresList && this.allVnStoresList.length > 0) {
            const found = this.allVnStoresList.find((s: any) => String(s.ID) === String(targetId));
            if (found && found.Name) {
                return found.Name;
            }
        }

        if (whVn && !isNumeric) {
            return whVn;
        }

        if (storeId) {
            return `Kho #${storeId}`;
        }
        return this.defaultWarehouseVn;
    }

    private get defaultWarehouseVn(): string {
        const cond = String((this.quotation && this.quotation.declaration_condition) || '').toUpperCase().trim();
        if (['ECL', 'EFC'].includes(cond)) {
            return 'Kho chính ngạch đường biển có VAT';
        }
        return 'Kho chính ngạch đường bộ có VAT';
    }

    private async loadPorts() {
        try {
            const res: any = await quotationServices.getPorts();
            if (res && res.data && res.data.status === 200 && Array.isArray(res.data.data)) {
                this.portsList = res.data.data;
            }
        } catch (e) {
            console.error('Không thể tải danh sách cảng:', e);
        }
    }

    private get departurePortList() {
        const fromApi = this.portsList.filter((p: any) => p.region === 'CHINA');
        if (fromApi.length > 0) {
            return fromApi;
        }
        return [
            { name: 'Cảng Nam Sa (Nansha)', code: 'NSA' },
            { name: 'Cảng XIAMEN', code: 'XMN' },
            { name: 'Cảng Quảng Châu', code: 'CAN' },
            { name: 'Cảng Thâm Quyến', code: 'SZX' },
            { name: 'Cảng Thượng Hải', code: 'SHA' },
            { name: 'Cảng Ninh Ba', code: 'NGB' },
        ];
    }

    private get arrivalPortList() {
        const fromApi = this.portsList.filter((p: any) => p.region === 'VIETNAM');
        if (fromApi.length > 0) {
            return fromApi;
        }
        return [
            { name: 'Cảng Cát Lái', code: 'SGN' },
            { name: 'Cảng Hải Phòng', code: 'HPH' },
            { name: 'Cảng Đà Nẵng', code: 'DAN' },
            { name: 'Cảng Cái Mép', code: 'CME' },
        ];
    }

    private async openPortModal() {
        if (this.portsList.length === 0) {
            await this.loadPorts();
        }
        this.editPortDeparture = this.quotation.port_departure || '';
        this.editPortArrival = this.quotation.port_arrival || '';
        this.showPortModal = true;
    }

    private closePortModal() {
        this.showPortModal = false;
    }

    private async savePorts() {
        this.isSavingPorts = true;
        try {
            const res: any = await quotationServices.updatePorts(this.quotation.id, {
                port_departure: this.editPortDeparture,
                port_arrival: this.editPortArrival,
            });

            if (res && res.data && res.data.status === 200) {
                this.quotation.port_departure = this.editPortDeparture;
                this.quotation.port_arrival = this.editPortArrival;
                this.showPortModal = false;
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thành công!',
                    text: 'Đã cập nhật thông tin cảng thành công!'
                });
            } else {
                const errMsg = (res && res.data && (res.data.reason || res.data.detail)) || 'Lỗi cập nhật cảng';
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Lỗi cập nhật!',
                    text: errMsg
                });
            }
        } catch (e) {
            const err = e as any;
            const errText = (err && err.message) ? err.message : 'Không thể kết nối máy chủ.';
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Lỗi hệ thống!',
                text: errText
            });
        } finally {
            this.isSavingPorts = false;
        }
    }

    // --- Kho Trung Quốc ---
    private async loadChinaStores() {
        try {
            const res: any = await commonService.getChinaStore();
            const list = (res && res.data && (res.data.data || res.data)) || [];
            this.allChinaStoresList = Array.isArray(list) ? list : [];
            // Lọc các kho có IsOfficial = 1 và IsHidden = 0 cho danh sách chọn
            let filtered = this.allChinaStoresList.filter((s: any) => (s.IsOfficial === 1 || s.IsOfficial === true || s.is_official === 1) && (!s.IsHidden || s.IsHidden === 0));
            if (filtered.length === 0) {
                // Fallback nếu flag IsOfficial chưa được đánh dấu trên môi trường hiện tại
                filtered = this.allChinaStoresList.filter((s: any) => (!s.IsHidden || s.IsHidden === 0));
            }
            this.chinaStoresList = filtered;
        } catch (e) {
            console.error('Không thể tải kho TQ:', e);
        }
    }

    private async openWarehouseCNModal() {
        if (this.chinaStoresList.length === 0) {
            await this.loadChinaStores();
        }
        const whCn = String(this.quotation.warehouse_cn || '').trim();
        const isNumeric = /^\d+$/.test(whCn);
        this.selectedChinaStoreId = this.quotation.legacy_china_store_id || (isNumeric ? parseInt(whCn, 10) : null);
        if (this.selectedChinaStoreId) {
            const found = this.allChinaStoresList.find(s => String(s.ID) === String(this.selectedChinaStoreId));
            this.selectedChinaStoreName = found ? found.Name : (whCn && !isNumeric ? whCn : '');
        } else {
            this.selectedChinaStoreName = whCn && !isNumeric ? whCn : '';
        }
        this.showWarehouseCNModal = true;
    }

    private closeWarehouseCNModal() {
        this.showWarehouseCNModal = false;
    }

    private onChinaStoreSelected() {
        const found = this.allChinaStoresList.find(s => String(s.ID) === String(this.selectedChinaStoreId));
        this.selectedChinaStoreName = found ? found.Name : '';
    }

    private async saveWarehouseCN() {
        if (!this.selectedChinaStoreId) return;
        this.isSavingWarehouse = true;
        try {
            const foundStore = this.allChinaStoresList.find(s => String(s.ID) === String(this.selectedChinaStoreId));
            const storeName = (foundStore ? foundStore.Name : '') || this.selectedChinaStoreName || '';
            const res: any = await quotationServices.updateWarehouses(this.quotation.id, {
                warehouse_cn: storeName,
                legacy_china_store_id: Number(this.selectedChinaStoreId),
            });

            if (res && res.data && res.data.status === 200) {
                this.quotation.warehouse_cn = storeName;
                this.quotation.legacy_china_store_id = Number(this.selectedChinaStoreId);
                this.showWarehouseCNModal = false;
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thành công!',
                    text: 'Cập nhật kho Trung Quốc thành công!'
                });
                this.$emit('refresh');
            } else {
                const errMsg = (res && res.data && (res.data.reason || res.data.detail)) || 'Lỗi cập nhật kho';
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thất bại!',
                    text: errMsg
                });
            }
        } catch (e) {
            const err = e as any;
            const errText = (err && err.response && err.response.data && err.response.data.reason) || (err && err.message) || 'Lỗi kết nối máy chủ';
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Lỗi hệ thống!',
                text: errText
            });
        } finally {
            this.isSavingWarehouse = false;
        }
    }

    // --- Kho Việt Nam ---
    private async loadVnStores() {
        try {
            const res: any = await commonService.getWarehouse();
            const list = (res && res.data && (res.data.data || res.data)) || [];
            this.allVnStoresList = Array.isArray(list) ? list : [];
            // Lọc các kho có IsOfficial = 1 và IsHidden = 0
            let filtered = this.allVnStoresList.filter((s: any) => (s.IsOfficial === 1 || s.IsOfficial === true || s.is_official === 1) && (!s.IsHidden || s.IsHidden === 0));
            if (filtered.length === 0) {
                // Fallback nếu flag IsOfficial chưa được đánh dấu trên môi trường hiện tại
                filtered = this.allVnStoresList.filter((s: any) => (!s.IsHidden || s.IsHidden === 0));
            }
            this.vnStoresList = filtered;
        } catch (e) {
            console.error('Không thể tải kho VN:', e);
        }
    }

    private async openWarehouseVNModal() {
        if (this.vnStoresList.length === 0) {
            await this.loadVnStores();
        }
        const whVn = String(this.quotation.warehouse_vn || '').trim();
        const isNumeric = /^\d+$/.test(whVn);
        this.selectedVnStoreId = this.quotation.legacy_receive_place_id || (isNumeric ? parseInt(whVn, 10) : null);
        if (this.selectedVnStoreId) {
            const found = this.allVnStoresList.find(s => String(s.ID) === String(this.selectedVnStoreId));
            this.selectedVnStoreName = found ? found.Name : (whVn && !isNumeric ? whVn : '');
        } else {
            this.selectedVnStoreName = whVn && !isNumeric ? whVn : '';
        }
        this.showWarehouseVNModal = true;
    }

    private closeWarehouseVNModal() {
        this.showWarehouseVNModal = false;
    }

    private onVnStoreSelected() {
        const found = this.allVnStoresList.find(s => String(s.ID) === String(this.selectedVnStoreId));
        this.selectedVnStoreName = found ? found.Name : '';
    }

    private async saveWarehouseVN() {
        if (!this.selectedVnStoreId) return;
        this.isSavingWarehouse = true;
        try {
            const foundStore = this.allVnStoresList.find(s => String(s.ID) === String(this.selectedVnStoreId));
            const storeName = (foundStore ? foundStore.Name : '') || this.selectedVnStoreName || '';
            const res: any = await quotationServices.updateWarehouses(this.quotation.id, {
                warehouse_vn: storeName,
                legacy_receive_place_id: Number(this.selectedVnStoreId),
            });

            if (res && res.data && res.data.status === 200) {
                this.quotation.warehouse_vn = storeName;
                this.quotation.legacy_receive_place_id = Number(this.selectedVnStoreId);
                this.showWarehouseVNModal = false;
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thành công!',
                    text: 'Cập nhật kho Việt Nam thành công!'
                });
                this.$emit('refresh');
            } else {
                const errMsg = (res && res.data && (res.data.reason || res.data.detail)) || 'Lỗi cập nhật kho';
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thất bại!',
                    text: errMsg
                });
            }
        } catch (e) {
            const err = e as any;
            const errText = (err && err.response && err.response.data && err.response.data.reason) || (err && err.message) || 'Lỗi kết nối máy chủ';
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Lỗi hệ thống!',
                text: errText
            });
        } finally {
            this.isSavingWarehouse = false;
        }
    }
}
